import { inject as service } from '@ember/service';
import { all } from 'rsvp';
import Route from 'cio/routes/base';

export default class IndexRoute extends Route {
  @service filters;
  @service store;

  model() {
    return this.store.findRecord('newsletter', this.paramsFor('broadcasts.newsletter').newsletter_id);
  }

  afterModel(model) {
    return all([model.findRecipients(), this.filters.process.perform()]);
  }
}
